export default {
  computed: {
    success() {
      return this.requestStatus && this.requestStatus === 'success';
    },
    loading() {
      return this.requestStatus && this.requestStatus === 'loading';
    },
    error() {
      return this.requestStatus && this.requestStatus === 'error';
    },
    emptyBot() {
      return this.requestStatus && this.requestStatus === 'emptyBot';
    },
  },
};
